import { StepNav } from 'slab'

import type { PayPeriod } from '../../types/payroll'
import { SkeletonItem } from '../reusable/SkeletonItem'

type PayDatePreviewProps = {
  isLoading: boolean
  data?: { data: PayPeriod[] }
  error?: string
}

export const PayDatePreview = ({ isLoading, data, error }: PayDatePreviewProps) => {
  if (!data?.data?.length && !isLoading) return null
  return (
    <div className='h-full p-4 rounded-lg border border-ds-border-secondary'>
      <p className='mb-4 text-sm text-ds-text-secondary'>
        Your next pay dates are:
      </p>
      {error && <div>Unable to load sample deductions dates</div>}
      {isLoading
        ? (
          <StepNav data-testid='pay-date-preview-skeleton'>
            <StepNav.Step
              active
              name={<SkeletonItem widthClass='w-32' />}
            />
            <StepNav.Step
              active
              name={<SkeletonItem widthClass='w-36' />}
            />
            <StepNav.Step
              active
              name={<SkeletonItem widthClass='w-28' />}
            />
          </StepNav>
          )
        : (
          <StepNav>
            {data?.data.map((period, index) => (
              <StepNav.Step
                key={index}
                active
                name={new Date(period.pay_date).toLocaleDateString('en-US', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  timeZone: 'UTC'
                })}
              />
            ))}
          </StepNav>
          )}
    </div>
  )
}
